import { numCompare } from "@common/Common";
import type { ValidationError } from "@common/types";
import type { DiscreteScaleLevel } from "@Scales/Model";

export class CriterionScaleEditorViewModel
{
    isOpen = false;

    criterionId: number | null = null;
    criterionName: string | null = null;
    criterionDescription: string | null = null;

    levels: DiscreteScaleLevel[] = [];

    error: string | null = null;

    show(
        criterionId: number,
        criterionName: string,
        criterionDescription: string | null,
        levels: DiscreteScaleLevel[] | null
    )
    {
        this.criterionId = criterionId;
        this.criterionName = criterionName;
        this.criterionDescription = criterionDescription;

        this.levels = levels
            ? [...levels].sort((a, b) => numCompare(a.Value, b.Value))
            : [];

        this.error = null;
        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;

        this.criterionId = null;
        this.criterionName = null;
        this.criterionDescription = null;

        this.levels = [];
        this.error = null;
    }

    displayValidationErrors(errors: ValidationError[])
    {
        const scaleError = errors.find(e => e.Context === 'ScaleLevels');
        this.error = scaleError?.Error ?? null;
    }
}
